import { useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actions as countryActions, } from '../../ducks/phoneCountry';
export const FetchCountriesList = ({ PHONE_COUNTRY_ACTIONS: { REQUEST }, countriesList, countriesListEU, language, countriesRange = ['ALL'], sortField, }) => {
    useEffect(() => {
        if (countriesRange.includes('ALL') && (!countriesList || language)) {
            REQUEST(Object.assign({ language }, (sortField && { sortField })));
        }
        if (countriesRange.includes('EU') && (!countriesListEU || language)) {
            REQUEST(Object.assign(Object.assign({ language }, (sortField && { sortField })), { countriesRange: 'EU' }));
        }
    }, [language]);
    return null;
};
const mapStateToProps = (state) => ({
    countriesList: state.phoneCountry.get('countriesList'),
    countriesListEU: state.phoneCountry.get('countriesListEU'),
    language: state.lang.get('lang'),
});
const mapDispatchToProps = (dispatch) => ({
    PHONE_COUNTRY_ACTIONS: bindActionCreators(countryActions, dispatch),
});
export default connect(mapStateToProps, mapDispatchToProps)(FetchCountriesList);
